<template lang="">
    <div id="header" :class="[(isMenuOpen ? 'menuOpen' : ''), (this.isHeaderFixed ? 'headerFixed' : ''), (this.onHeaderLeave ? 'headerLeave' : '')]">
        <div id="header_inner">
            <a href="https://new7.storm.mg" id="header_logo" target="_blank">
                <svg id="header_logo_img" class="new7_logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 45">
                    <g class="new7_logo_inner" >
                        <path d="M108.63,9.79h10.12v4.88H108.63Zm10.12-1H108.63V4.06h10.12Zm0,9.41c2.91,0,4-1,4-1.19V5a3.57,3.57,0,0,0,2-.86L120,1l-1.7,2H108.9l-4.46-1.85V44.23c3.82,0,4.19-1.53,4.19-1.62V15.72h10.12Zm14.14-8.36h10.59v4.88H132.89Zm10.59-1H132.89V4.06h10.59ZM143,3h-9.8l-4.34-1.67V18c3.48,0,4.07-1.24,4.07-1.29v-1h10.59V38.93c0,.53-.21.67-.84.67h-5.36v.64c3.39.38,4.72.81,4.72,4,5-.48,5.72-2.44,5.72-5.29V5.11a4.48,4.48,0,0,0,2.28-1L144.86.73ZM131,32v3.43c-3.5.19-6.94.39-10,.53V32.05Zm-10-9.55h10v3.68H121ZM131,31H121V27.24h10Zm5-12.32-2.33,2.72h-22l.32,1.1h5.09v13.7c-2.12.09-3.87.19-5.14.19l2.33,4.16a1.68,1.68,0,0,0,1.32-1c6.63-1.2,11.66-2.15,15.37-2.92v6.63h.62c2.07,0,3.29-.76,3.34-1V22.5H138c1.38,0,2-.29,2.44-1Z" />
                        <path d="M25.49,7.3,20.18,3.55,17.31,7.24h-.83v-5c1.45-.19,1.91-.51,2-1.16L9.27.25v7H1L1.21,8H23.07c1.34,0,2.06-.14,2.42-.65M4.43,8.51a13.89,13.89,0,0,1,1,5.29,11.24,11.24,0,0,1-.26,2.65A3.34,3.34,0,0,0,8,18a3.54,3.54,0,0,0,3.6-3.35c0-1.9-1.7-4.27-6.69-6.36ZM42.19.56,41.82.3a43,43,0,0,1-7.93,5.88l-7.42-2V18.07l-5.21-3.34-2.87,3.34H15.61a54.82,54.82,0,0,0,7-7.38c1.34,0,1.81-.28,2-.84L16,8.13a97.51,97.51,0,0,1-1.44,9.94H.21l.2.75H9.32v6.42H.72L.93,26H8A37.66,37.66,0,0,1,0,40.46l.46.6a40.14,40.14,0,0,0,8.86-6.13v9.56h1.39c2.48,0,5.67-1.26,5.67-1.77V29.45a10.54,10.54,0,0,1,2.11,6.36,3.74,3.74,0,0,0,2.72,1.26c1.86,0,3.61-1.44,3.61-3.11,0-1.91-2.11-4.09-8.39-5.11h-.05V26h7.1c1.34,0,2.06-.14,2.42-.65L20.75,21.6l-2.82,3.64H16.38V19.61c.93-.14,1.24-.42,1.29-.79H24.2a3.47,3.47,0,0,0,2.27-.47v1.58c0,8.5-.62,17.18-7.11,24l.46.46c12.88-6,13.81-15.87,13.81-24.27V18.44h3.66v26h1.33A12.68,12.68,0,0,0,42.19,44V14l-2.9,3.71H33.63V8c3-.3,6-.75,8.56-1.26Z" />
                        <path d="M58,8.74a15.35,15.35,0,0,1,1.75,6.83,5,5,0,0,1-.06,1.1,2.28,2.28,0,0,0,1.75,1,2.61,2.61,0,0,0,2.39-2.77c0-1.77-1.28-4.11-5.2-6.36ZM68.31,26.37h8.58c1.43,0,2.07-.29,2.44-1l-4.4-3L72.6,25.24H68.31V19.49c1-.1,1.37-.29,1.58-.53h7.85c1.43,0,2.06-.28,2.49-.95L75.56,15.1l-2.38,2.77H69.52a71,71,0,0,0,5.36-7.31c1.21,0,1.74-.19,1.9-.77l-6-1.43a91.27,91.27,0,0,1-2.55,9.51H53.53L53.85,19H64.17v6.28h-10l.32,1.1h8.26a37.77,37.77,0,0,1-9.43,14.14l.66.76a36.1,36.1,0,0,0,10.16-9.07V44.75c3.55,0,4.14-1.15,4.14-1.25V29.76c2.17,1.67,4.5,4.39,5,6.69a2.66,2.66,0,0,0,1.64.62,2,2,0,0,0,2-2V35c0-1.92-2.06-4.49-8.63-5.88h0Zm27.54-9H85.63V6.83A91.27,91.27,0,0,0,99.71,4a5.06,5.06,0,0,0,1.59.23,1.71,1.71,0,0,0,1.22-.33L97.59.3A65.46,65.46,0,0,1,86.21,5.54L81.45,4.11V20c0,9.08-1.22,17.49-9.06,24.12l.68.57c11.34-6.3,12.56-15.94,12.56-24.64V18.44h7V44.75h.69c2.17,0,3.54-.91,3.54-1.15V18.44h4.3c1.43,0,2.11-.29,2.54-1l-5.09-3.39ZM76.46,7.93c1.49,0,2.07-.29,2.5-1l-4.56-3L72,6.83H68.36V2C70,1.73,70.48,1.44,70.53.73L64.17.25V6.83H54.49l.32,1.1Z" />
                        <path d="M49.43,43.67V42.34H47a1.05,1.05,0,0,0-.67.19.65.65,0,0,0-.21.5.85.85,0,0,0,.08.42.75.75,0,0,0,.27.29v0a1,1,0,0,1-.28-.14.92.92,0,0,1-.28-.24,1.55,1.55,0,0,1-.19-.36,1.57,1.57,0,0,1-.07-.49,1.12,1.12,0,0,1,.06-.35.92.92,0,0,1,.18-.3,1,1,0,0,1,.25-.21.57.57,0,0,1,.29-.08h3V41h.1l1.21,1.24v.07H50v1.62Zm-3-2.81A1.26,1.26,0,0,1,46,40.5a1.51,1.51,0,0,1-.23-.52,2.7,2.7,0,0,1-.08-.62,3,3,0,0,1,.08-.73A2.34,2.34,0,0,1,46,38h1.2v.07l-.49.17a2,2,0,0,0-.45.25,1.14,1.14,0,0,0-.33.36.83.83,0,0,0-.14.49A1,1,0,0,0,46,40a1.07,1.07,0,0,0,.77.25.73.73,0,0,0,.47-.17.87.87,0,0,0,.25-.47,1.73,1.73,0,0,1,.1-.45c0-.14.08-.28.12-.39a1,1,0,0,1,.41-.54,1.15,1.15,0,0,1,.7-.2,1,1,0,0,1,.51.11,1.16,1.16,0,0,1,.39.31,1.26,1.26,0,0,1,.25.44,1.61,1.61,0,0,1,.09.54,3.69,3.69,0,0,1-.07.65,5.6,5.6,0,0,1-.17.54l-1.13.1v-.07l.51-.24.4-.28a1.35,1.35,0,0,0,.26-.33,1.12,1.12,0,0,0,.09-.44.94.94,0,0,0-.06-.29.72.72,0,0,0-.16-.25.76.76,0,0,0-.26-.18.81.81,0,0,0-.37-.07.57.57,0,0,0-.48.18,1.08,1.08,0,0,0-.22.47,1.22,1.22,0,0,1-.09.42l-.1.39a1.39,1.39,0,0,1-.42.67A1.24,1.24,0,0,1,47,41a1.43,1.43,0,0,1-.61-.14m-.72-4.94h.09v.21a.6.6,0,0,0,0,.19.42.42,0,0,0,.09.14.19.19,0,0,0,.13,0h3.25a.23.23,0,0,0,.1-.07l.11-.19a2.29,2.29,0,0,0,.1-.23h.06l.4,1.18H46a.17.17,0,0,0-.13.07.35.35,0,0,0-.06.14.48.48,0,0,0,0,.17v.18h-.09Zm5.48,1.25a.43.43,0,0,1-.19-.32.41.41,0,0,1,.15-.33.4.4,0,0,1,.34-.14.45.45,0,0,1,.48.47.47.47,0,0,1-.45.47h0a.48.48,0,0,1-.35-.14m-5.48-3.28h.1a1.6,1.6,0,0,0,.09.53.21.21,0,0,0,.2.13h5.34a.27.27,0,0,0,.08-.07l.14-.24.15-.26h0l.46,1.26H46a.17.17,0,0,0-.14,0,.23.23,0,0,0-.06.12.67.67,0,0,0,0,.2v.29h-.1Zm2.48-1.32a2.42,2.42,0,0,1-.25-.4l-.29-.46a2.05,2.05,0,0,0-.34-.38.61.61,0,0,0-.42-.16.66.66,0,0,0-.43.15.49.49,0,0,0-.19.42,1.34,1.34,0,0,0,0,.4.85.85,0,0,0,.21.32.35.35,0,0,0,.26.11Zm-1.92,1.55a1.17,1.17,0,0,1-.3-.19.63.63,0,0,1-.2-.26.83.83,0,0,1-.07-.34.72.72,0,0,1,.19-.53.71.71,0,0,1,.63-.23h0a2.48,2.48,0,0,1-.26-.19,1.85,1.85,0,0,1-.28-.28,1.58,1.58,0,0,1-.2-.36,1.09,1.09,0,0,1-.08-.43,1.4,1.4,0,0,1,0-.29.7.7,0,0,1,.42-.45.89.89,0,0,1,.4-.07.75.75,0,0,1,.49.19,2.26,2.26,0,0,1,.43.49l.32.51.24.39c.06.11.11.21.16.29s.09.16.12.22h1l.14-.11a1.37,1.37,0,0,0,.13-.2,1,1,0,0,0,.06-.35,1.17,1.17,0,0,0,0-.27,1.36,1.36,0,0,0-.13-.24,1.29,1.29,0,0,0-.15-.17.2.2,0,0,0-.14-.06H48.7a.25.25,0,0,1-.22-.13.35.35,0,0,1-.1-.27.28.28,0,0,1,.1-.24.31.31,0,0,1,.24-.1.29.29,0,0,1,.2.05.7.7,0,0,1,.17.13l.12.17.1.16.27.47c.08.15.15.3.22.45a3.15,3.15,0,0,1,.14.39,1.36,1.36,0,0,1,.06.29.86.86,0,0,1-.43.72H47a.75.75,0,0,0-.54.13.4.4,0,0,0-.13.31.42.42,0,0,0,.08.3.41.41,0,0,0,.22.13v.09a1.14,1.14,0,0,1-.33-.07m-.56-5.64h.1a.73.73,0,0,0,.06.38.18.18,0,0,0,.19.14h2.29a1.69,1.69,0,0,0,.85-.2.69.69,0,0,0,.32-.64,1,1,0,0,0-.12-.49,2.83,2.83,0,0,0-.43-.48H46a.2.2,0,0,0-.13.06.21.21,0,0,0-.06.1.33.33,0,0,0,0,.14v.17h-.09V26h.09a1,1,0,0,0,.09.34.2.2,0,0,0,.2.15h3.24l.08-.08.08-.2.1-.21h.06l.43,1.14v.07h-1l.34.24a3.34,3.34,0,0,1,.32.33,1.67,1.67,0,0,1,.25.43,1.4,1.4,0,0,1,.1.46.91.91,0,0,1-.4.77,1.77,1.77,0,0,1-1,.27H46a.11.11,0,0,0-.11.06.54.54,0,0,0-.07.13v.35h-.08ZM49.31,26a.37.37,0,0,1-.13-.27.41.41,0,0,1,0-.22.49.49,0,0,1,.11-.14l.12-.14a.31.31,0,0,0,0-.19.36.36,0,0,0-.08-.2,1.19,1.19,0,0,0-.2-.19,1.4,1.4,0,0,0-.26-.16l-.29-.12H46a.24.24,0,0,0-.13.11.66.66,0,0,0-.06.2.89.89,0,0,0,0,.23v.2h-.09v-2h.09a1.06,1.06,0,0,0,.09.35.22.22,0,0,0,.2.14h3.19a.3.3,0,0,0,.08-.08l.11-.18.12-.21h0l.47,1.15v.05H48.79l.32.14a4.49,4.49,0,0,1,.42.24,1.8,1.8,0,0,1,.37.36.84.84,0,0,1,.16.48.59.59,0,0,1-.14.38.47.47,0,0,1-.35.15.55.55,0,0,1-.33-.11m-3.59-4.28v-.08h.93l-.33-.23a1.57,1.57,0,0,1-.31-.32,1.26,1.26,0,0,1-.22-.39,1,1,0,0,1-.08-.46,1,1,0,0,1,.34-.82,1.59,1.59,0,0,1,1-.27h2.7a.35.35,0,0,0,.11-.1.47.47,0,0,0,.06-.15v-.33H50v1.35H47.34a1.82,1.82,0,0,0-.89.17.72.72,0,0,0-.28.66.86.86,0,0,0,0,.32,1.15,1.15,0,0,0,.12.25,1.12,1.12,0,0,0,.18.2l.21.17H49.5a.63.63,0,0,0,.22-.07,2.46,2.46,0,0,0,.07-.29V21H50v1.47h-3.7l-.08.08-.12.23c-.05.1-.08.19-.12.26h0Zm2.91-4a2.54,2.54,0,0,0,.66-.21,1.35,1.35,0,0,0,.49-.4,1,1,0,0,0,.2-.6.88.88,0,0,0-.18-.52,1.79,1.79,0,0,0-.48-.39,2.61,2.61,0,0,0-.66-.24,3.82,3.82,0,0,0-.75-.08,4.15,4.15,0,0,0-.79.07,2.14,2.14,0,0,0-.66.22,1.3,1.3,0,0,0-.46.41.94.94,0,0,0-.17.58.78.78,0,0,0,.22.58,1.5,1.5,0,0,0,.53.37,2.83,2.83,0,0,0,.7.21,3.17,3.17,0,0,0,.69.07,3,3,0,0,0,.66-.07M47,18.41a2.43,2.43,0,0,1-.72-.45,1.93,1.93,0,0,1-.48-.65,1.68,1.68,0,0,1-.17-.79,2.16,2.16,0,0,1,.12-.71,2.1,2.1,0,0,1,1.12-1.18,2.42,2.42,0,0,1,1-.2,2.28,2.28,0,0,1,.81.15,2.75,2.75,0,0,1,.69.43,2.28,2.28,0,0,1,.48.67A2,2,0,0,1,50,17.24a2.1,2.1,0,0,1-.41.65,2,2,0,0,1-.67.48,2.24,2.24,0,0,1-.95.19,2.41,2.41,0,0,1-.88-.16m5-4.49a.65.65,0,0,0-.29-.34,1.8,1.8,0,0,0-.39-.08H46.88a.84.84,0,0,1-.51-.14A2,2,0,0,1,46,13a1.83,1.83,0,0,1-.32-.58,1.54,1.54,0,0,1-.1-.56,1.22,1.22,0,0,1,0-.27.8.8,0,0,1,.11-.25.45.45,0,0,1,.19-.17.59.59,0,0,1,.29-.07.48.48,0,0,1,.36.16.54.54,0,0,1,.14.36.45.45,0,0,1-.14.3.42.42,0,0,1-.31.13.3.3,0,0,1-.3-.13.54.54,0,0,1-.13-.3h0a.34.34,0,0,0-.09.12.38.38,0,0,0,0,.15.46.46,0,0,0,.14.35.8.8,0,0,0,.36.2,1.69,1.69,0,0,0,.45.07H51.7a.48.48,0,0,0,.18-.08.6.6,0,0,0,.21-.34,3.73,3.73,0,0,1,.08-.44h.09v2.7h-.09c0-.13-.06-.27-.1-.4" />
                        <path d="M49.29,8.32a.73.73,0,0,0,.2-.51.67.67,0,0,0-.13-.38,1.59,1.59,0,0,0-.29-.29A3.9,3.9,0,0,0,48.72,7l-.27-.08v.57a1.22,1.22,0,0,0,0,.27V8a.74.74,0,0,0,0,.21.48.48,0,0,0,0,.17l.11.08a.22.22,0,0,0,.16,0,.73.73,0,0,0,.5-.19m-2.61.85a1.24,1.24,0,0,1-.39-.29A1.09,1.09,0,0,1,46,8.46a1.18,1.18,0,0,1-.12-.56A1.52,1.52,0,0,1,46,7.24a1.49,1.49,0,0,1,.41-.53A2,2,0,0,1,47,6.37a2.68,2.68,0,0,1,.8-.13,2.32,2.32,0,0,1,.64.11,2.19,2.19,0,0,1,.58.32,1.64,1.64,0,0,1,.41.5,1.36,1.36,0,0,1,.16.65,2,2,0,0,1-.08.55,1.15,1.15,0,0,1-.63.75,1.25,1.25,0,0,1-.56.14V6.85H48a2.18,2.18,0,0,0-.63.09,1.68,1.68,0,0,0-.52.3,1.21,1.21,0,0,0-.49,1,1,1,0,0,0,.2.65.84.84,0,0,0,.48.37v.06a1.32,1.32,0,0,1-.38-.13m-.81-4.53H46A1.63,1.63,0,0,0,46,5a.15.15,0,0,0,.16.14h1.93a1.48,1.48,0,0,0,.42,0A.86.86,0,0,0,48.88,5a.45.45,0,0,0,.22-.21.77.77,0,0,0,.08-.34,1.27,1.27,0,0,0-.1-.46,1.06,1.06,0,0,0-.27-.29H46.18a.11.11,0,0,0-.11,0,.14.14,0,0,0,0,.09.33.33,0,0,0,0,.14v.14h-.18V2.56H46a1.81,1.81,0,0,0,0,.31.2.2,0,0,0,.19.14h4.49L50.79,3c0-.06.07-.11.1-.16a.78.78,0,0,1,.11-.2h0l.47,1v.06H48.79A1.65,1.65,0,0,1,49,3.8a1.66,1.66,0,0,1,.26.27,2.71,2.71,0,0,1,.21.37,1.27,1.27,0,0,1,.09.47.91.91,0,0,1-.09.41.67.67,0,0,1-.24.26.93.93,0,0,1-.38.14,1.85,1.85,0,0,1-.47,0H46.07a.3.3,0,0,0-.06.11A.33.33,0,0,0,46,6a.33.33,0,0,0,0,.14h-.12Zm3.18-2.13V1.4h-2a.77.77,0,0,0-.57.16.51.51,0,0,0-.18.42.66.66,0,0,0,.07.36.77.77,0,0,0,.23.25h0l-.24-.12a.83.83,0,0,1-.24-.21A1,1,0,0,1,46,2a1,1,0,0,1-.06-.41.76.76,0,0,1,0-.3A1,1,0,0,1,46.07,1a.52.52,0,0,1,.22-.14.4.4,0,0,1,.24-.07h2.54V.25h.09l1.06,1.07v.06h-.68V2.76Z" />
                    </g>
                </svg>
            </a>
            <div id="navigation_wrapper">
                <a href="javascript:void(0);" class="nav_link" v-for="(item, key) in articleItem" :key="key" @click="scrollToArticle(key, 'nav')">{{item.itemCategory}}</a>
            </div>
            <a href="javascript:void(0);" id="navigation_btn" :class="isMenuOpen ? 'menuOpen' : ''" @click="menu()">
                <span class="nav_line top"></span>
                <span class="nav_line middle"></span>
                <span class="nav_line bottom"></span>
            </a>
        </div>
        <div id="slide_menu">
            <div id="slide_menu_inner">
                <div id="slide_menu_top">
                    <a href="javascript:void(0);" class="slide_menu_link" v-for="(item, key) in articleItem" :key="key" @click="scrollToArticle(key, 'slideMenu')">
                        <span class="link_text">{{item.itemCategory}}</span>
                    </a>
                </div>
                <div id="slide_menu_botom">
                    <a href="https://events.storm.mg/new7-support-us/?utm_campaign=new7_support_us&utm_source=new7&utm_medium=project_MRT" id="header_supportUs_btn" class="btn" target="_blank">
                        <span class="btn_text">贊助我們</span>
                    </a>
                    <p id="header_copyright" class="copyright">Copyright © 2022 Storm Media Group All Rights Reserved. ◎未經授權．不得轉載</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HeaderComponent',
    data() {
        return {
            isMenuOpen: false,
            articleItem: this.data.articleItem
        }
    },
    props: {
        data: {},
        isShowContent: {
            type: Boolean
        },
        isHeaderFixed: {
            type: Boolean
        },
        onHeaderLeave: {
            type: Boolean
        },
    },
    methods: {
        menu() {
            if(this.isMenuOpen) {
                this.isMenuOpen = false;
                document.body.classList.remove('menuOpen');
            } else {
                this.isMenuOpen = true;
                document.body.classList.add('menuOpen');
            }
        },
        scrollToArticle(key, type) {
            let currentKey = key;
            let targetArticle = document.getElementById('article_'+currentKey);
            let targetArticleTop = 0;
            
            console.log(targetArticleTop);
            
            if(type == 'slideMenu') {
                this.menu();
            }
            
            if(window.scrollY == 0) {
                window.scrollTo(0,1);
                setTimeout(function() {
                    targetArticleTop = targetArticle.getBoundingClientRect().top + window.scrollY - 72;
                    window.scrollTo(0, targetArticleTop);
                },600);
            } else {
                targetArticleTop = targetArticle.getBoundingClientRect().top + window.scrollY - 72;
                window.scrollTo(0, targetArticleTop);
            }
        },
        handleResize() {
        this.isMenuOpen = false;
        },
    },
    mounted() {
        // detect resize
        window.addEventListener("resize", this.handleResize);
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/libs.scss";
#header {
    position: fixed;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 10;

    &.menuOpen {

        #header_inner {
            background-color: $white;
            transition: background-color .3s $transition_ease_out;

            #header_logo {

                #header_logo_img {
                    fill: $new7_color;
                    transition: fill .3s $transition_ease_out;
                }
            }
        }

        #slide_menu {
            right: 0;
            transition: right .3s $transition_ease_out;

            #slide_menu_inner {
                opacity: 1;
                transition: opacity .3s .3s $transition_ease_out;
            }
        }
    }

    #header_inner {
        position: relative;
        padding: 12px 24px;
        background-color: transparent;
        transition: background-color .3s $transition_ease_in;

        @media (min-width: 768px) {
            padding: 12px 48px;
        }

        @media (min-width: 1024px) {
            padding: 38px 0 0;
            text-align: center;
        }

        @media (min-width: 1440px) {
            padding: 56px 0 0;
        }

        @media (min-width: 2560px) {
            padding: 86px 0 0;
        }

        #header_logo {
            display: inline-block;
            vertical-align: bottom;
            height: 24px;
            line-height: 1;

            @media (min-width: 1024px) {
                margin-right: 48px;
                height: 32px;
            }

            @media (min-width: 1440px) {
                margin-right: 72px;
                height: 48px;
            }

            @media (min-width: 2560px) {
                margin-right: 88px;
                height: 56px;
            }

            #header_logo_img {
                height: 100%;
                fill: $white;
                line-height: 0;
                transition: fill .3s $transition_ease_in;
            }
        }

        #navigation_wrapper {
            display: none;
            vertical-align: bottom;
            line-height: 1;

            .nav_link {
                display: inline-block;
                margin-right: 48px;
                font-size: 16px;
                font-weight: $fw_regular;
                line-height: 1;
                color: $white;

                @media (min-width: 1440px) {
                    margin-right: 72px;
                    font-size: 18px;
                }
                @media (min-width: 2560px) {
                    margin-right: 88px;
                    font-size: 24px;
                }

                &:last-of-type {
                    margin-right: 0;
                }
            }

            @media (min-width: 1024px) {
                display: inline-block;
            }
        }

        #navigation_btn {
            position: absolute;
            top: 12px;
            right: 25px;
            display: inline-block;
            width: 24px;
            height: 24px;
            padding: $spacing/2 0;
            
            @media (min-width: 768px) {
                right: 48px;
            }

            @keyframes nav_btn_top {
                0% {
                    top: 5px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                33% {
                    top: 11px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                66% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                100% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_out;
                }
            }

            @keyframes nav_btn_top_reverse {
                0% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                33% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                66% {
                    top: 11px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }

                100% {
                    top: 5px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }
            }

            @keyframes nav_btn_middle {
                0% {
                    opacity: 1;
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                33% {
                    opacity: 0;
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                66% {
                    opacity: 0;
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                100% {
                    opacity: 0;
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_out;
                }
            }

            @keyframes nav_btn_middle_reverse {
                0% {
                    opacity: 0;
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                33% {
                    opacity: 0;
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                66% {
                    opacity: 0;
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }

                100% {
                    opacity: 1;
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }
            }

            @keyframes nav_btn_bottom {
                0% {
                    top: 17px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                33% {
                    top: 11px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_in_out;
                }

                66% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                100% {
                    top: 11px;
                    transform: rotate(225deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_out;
                }
            }

            @keyframes nav_btn_bottom_reverse {
                0% {
                    top: 11px;
                    transform: rotate(225deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                33% {
                    top: 11px;
                    transform: rotate(135deg);
                    background-color: $gray_1;
                    animation-timing-function: $transition_ease_in;
                }

                66% {
                    top: 11px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }

                100% {
                    top: 17px;
                    transform: rotate(0);
                    background-color: $white;
                    animation-timing-function: $transition_ease_out;
                }
            }

            &.menuOpen {
                
                .nav_line {
                    
                    &.top {
                        top: 11px;
                        transform: rotate(135deg);
                        background-color: $gray_1;
                        animation: nav_btn_top .45s;
                    }

                    &.middle {
                        opacity: 0;
                        background-color: $gray_1;
                        animation: nav_btn_middle .45s;
                    }

                    &.bottom {
                        top: 11px;
                        transform: rotate(225deg);
                        background-color: $gray_1;
                        animation: nav_btn_bottom .45s;
                    }
                }
            }

            .nav_line {
                position: absolute;
                display: block;
                width: 24px;
                height: 2px;
                background-color: $white;

                &.top {
                    top: 5px;
                    animation: nav_btn_top_reverse .45s;
                }

                &.middle {
                    top: 11px;
                    opacity: 1;
                    animation: nav_btn_middle_reverse .45s;
                }

                &.bottom {
                    top: 17px;
                    animation: nav_btn_bottom_reverse .45s;
                }
            }

            @media (min-width: 1024px) {
                display: none;
            }
        }
    }

    #slide_menu {
        position: absolute;
        right: -100%;
        width: 100%;
        height: calc(100vh - 48px);
        padding: 40px 24px 24px;
        text-align: center;
        background-color: $white;
        transition: right .3s $transition_ease_in;

        #slide_menu_inner {
            opacity: 0;
            transition: opacity .2s $transition_ease_in;
        }

        #slide_menu_top {
            height: calc(100vh - 120px);
            overflow: hidden;
            overflow-y: scroll;
            padding-bottom: 20px;

            @media (min-height: 521px) {
                height: calc(100vh - 250px);
            }

            .slide_menu_link {
                display: block;
                margin-bottom: 24px;
                font-size: 20px;
                line-height: 1;
                font-weight: $fw_medium;

                @media (min-width: 768px) {
                    margin-bottom: 64px;
                    font-size: 24px;
                }

                @media (max-height: 720px) {
                    margin-bottom: 24px;
                }

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }

        #slide_menu_botom {
            position: absolute;
            bottom: 15%;
            left: 0;
            width: 100%;
            height: auto;
            padding-top: 5px;

            @media (max-height: 520px) {
                display: none;
            }

            @media (min-width: 768px) {
                bottom: 24px;
            }

            #header_supportUs_btn {
                margin-bottom: 24px;

                @media (min-width: 768px) {
                    @include btn_lg;
                    margin-bottom: 48px;
                }
            }
        }

        @media (min-width: 768px) {
            padding: 64px 48px 24px;
        }

        @media (max-height: 520px) {
            padding-top: 40px;
        }
    }
}
</style>